"use strict";

import Page from "./Permit.jsx";

export const auth = true;
export const title = "i18n:permits.permitInformation";
export const Component = Page;
